module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"ac-text-1":"Maksupäivä:","ac-text-2":"Lopetuspäivä:"},"se":{"ac-text-1":"Betalningsdag:","ac-text-2":"Slutdatum:"},"en":{"ac-text-1":"Payment date:","ac-text-2":"End date:"}}')
  delete Component.options._Ctor
}
